<div style="cursor: pointer; color: blue; font-size: 18px; margin-left: 20px; margin-top: 30px;"
    (click)="downloadReadyPdf()">Download LE Assessment</div>
<div #toPdf class="pdfPage" style="margin: auto;">
    <div style="width: 100%; height: 297mm;">
        <div class="headerImgTxt">
            <img class="logoImg"
                src="https://list-upload-files-test.s3.us-east-2.amazonaws.com/PdfStatticFiles/list_logo_colored.jpg"
                alt="Logo">
            <div>Powered by AI</div>
            <!-- <div class="logo">October 15, 2023</div> -->
        </div>

        <div class="pageTitle">Life Expectancy Assessment</div>
        <div class="header">
            <div class="info-card">
                <div class="info-section" *ngFor="let item of predictionData">
                    <div class="info-header">{{item.header}}</div>
                    <div class="info-value">{{item.highlightValue}}</div>
                </div>
            </div>
            <div class="info-card">
                <div class="info-section" *ngFor="let item of medicalHistoryInfo">
                    <div class="info-header">{{item.header}}</div>
                    <div class="info-value">{{item.highlightValue}}</div>
                </div>
            </div>

        </div>

        <div style="margin-top: -40px; margin-left: 16px;">
            <div  style="font-weight: 800; font-size: 20px;">
                Key contributing factors to the life expectancy forecast:
            </div>
            <div id="keyContributing">
               {{pdfData['keyContributing']}}
            </div>
        </div>


        <div class="row" *ngIf="leData" style="margin-top: 16px;">
            <div class="col-md-6List" style="position: relative; left: 15px;">
                <div #chart_line_lives style="width: 400px; height: 240px;"></div>
            </div>
            <div class="col-md-6List">
                <div #chart_line_lives2 style="width: 400px; height: 240px;"></div>
            </div>
        </div>

        <div class="row" *ngIf="leTablesData">
            <div class="col-md-6List">
                <div style="display: flex; flex: 1;">
                    <table>
                        <thead>
                            <th>Years</th>
                            <th>%</th>
                        </thead>
                        <tbody>
                            <ng-container
                                *ngFor="let item of leTablesData['lives']; let i = index;">
                                <tr *ngIf="i < 15">
                                    <td>{{i + 1}}</td>
                                    <td>{{item | number: '1.1-1'}}%</td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>

                    <table>
                        <thead>
                            <th>Years</th>
                            <th>%</th>
                        </thead>
                        <tbody>
                            <ng-container
                                *ngFor="let item of leTablesData['lives']; let i = index;">
                                <tr *ngIf="i >= 15">
                                    <td>{{i + 1}}</td>
                                    <td>{{item | number: '1.1-1'}}%</td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>

                </div>
            </div>
            <div class="col-md-6List">
                <div style="display: flex; flex: 1;">
                    <table>
                        <thead>
                            <th>Years</th>
                            <th>%</th>
                        </thead>
                        <tbody>
                            <ng-container
                                *ngFor="let item of leTablesData['dies']; let i = index;">
                                <tr *ngIf="i < 15">
                                    <td>{{i + 1}}</td>
                                    <td>{{ item | number: '1.1-1' }}%</td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>

                    <table>
                        <thead>
                            <th>Years</th>
                            <th>%</th>
                        </thead>
                        <tbody>
                            <ng-container
                                *ngFor="let item of leTablesData['dies']; let i = index;">
                                <tr *ngIf="i >= 15">
                                    <td>{{i + 1}}</td>
                                    <td>{{ item | number: '1.1-1' }}%</td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>

                </div>
            </div>

        </div>
    </div>
    <div class="disclaimer">
        <div style="width: 100%; height: 245mm; margin-top: 50px; text-align: justify">
            <h2
                style='     width: 100%;
        margin-top:3.0pt;margin-right:0cm;margin-bottom:3.0pt;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
                <u><span style="font-size:12px;color:black;">LiST&rsquo;s DISCLAIMERS&nbsp;</span></u>
            </h2>
            <h2
                style='margin-top:3.0pt;margin-right:0cm;margin-bottom:3.0pt;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;text-align:justify;'>
                <span style="font-size:12px;color:black;font-weight:normal;">&nbsp;</span>
            </h2>
            <p
                style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;text-align:justify;'>
                <span style="font-size:12px;color:black;">LiST Funding, Inc (&ldquo;LiST&rdquo;) provides data for life
                    expectancy estimates by applying proprietary methods, systems and resources to written health and
                    medical information provided by or on behalf its client to LiST. Life expectancy projections
                    prepared by
                    LiST are only estimates of estimated future mortality and are not guarantees of actual mortality
                    results. LiST does not represent<strong>,</strong> warrant <strong>or guarantee&nbsp;</strong>to any
                    client or other person that an insured will die on or near any projected mortality
                    date<strong>&nbsp;prepared by LiST</strong>. Client acknowledges that there may be information that
                    materially affects an estimated life expectancy of an insured that has not been provided to LiST and
                    which could materially alter any life expectancy estimate provided by LiST to its client.
                    LiST</span><span style="font-size:12px;">&nbsp;is&nbsp;</span><span style="font-size:12px;">not a
                    licensed insurance advisor, agency, brokerage, consultant, counselor or producer; life settlement
                    provider or broker; or registered investment advisor. If any medical data provided to LiST are
                    illegible
                    or otherwise of poor quality, LiST may be unable to incorporate such data into its <span
                        style="color:black;">life expectancy estimate</span>, and if such information is incorporated
                    into
                    it its <span style="color:black;">life expectancy estimate,</span> such data may materially alter
                    LiST&rsquo;s <span style="color:black;">life expectancy estimate</span>.<span
                        style="color:black;">&nbsp;LiST</span> expressly disclaims and nothing contained herein is
                    intended
                    to be, and shall not be, construed or interpreted, to mean, that <span
                        style="color:black;">LiST</span>
                    is rendering any actuarial, estate planning, financial planning, insurance, investment, legal, tax
                    or
                    any other type of advice, counsel or opinion to any person. LiST does not transact business as a
                    life
                    expectancy provider or estimator in Florida or Texas. <span style="color:black;">LiST</span> does
                    not
                    create, accept or assume, and expressly disclaims creating, accepting or assuming, any fiduciary
                    obligation or liability to Client, any life insurance policy owner, insured or beneficiary or
                    purchaser
                    of or investor in any life insurance policy. All estimated life expectancy reports prepared by <span
                        style="color:black;">LiST</span> are subject to all the terms, conditions and limitations of
                    liability contained in the <span style="color:black;">LiST&rsquo;s</span> Terms of Service for
                    purchasing a LiST <span style="color:black;">life expectancy estimate</span>. Client acknowledges
                    and
                    agrees that any information contained in a <span style="color:black;">life expectancy
                        estimate</span>
                    provided to client by LiST shall not be used by client in any manner that violates any applicable
                    law.
                    This LiST estimated life expectancy reports was prepared using LiST&rsquo;s current methodology.
                    From
                    time‐to‐time, LiST may develop new methodologies or data analytics using methods that differ from
                    its
                    then current standard methodology, and new methodologies may include different or additional data,
                    analysis, algorithms or technology than those used by LiST for this estimated life expectancy report
                    and
                    may result in different life expectancy estimate for the same individual, which may be materially
                    different than this estimated life expectancy report for that same individual.</span>
            </p>
            <h1
                style='margin-top:24.0pt;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;text-align:justify; line-height: normal;'>
                <span style="font-size:12px;font-weight:normal;">LiST&nbsp;</span><span
                    style="font-size:12px;font-weight:normal;">PROVIDES ITS SERVICES TO CLIENT ONLY &quot;AS IS,&quot;
                    &ldquo;WHERE IS,&rdquo; &ldquo;WITH ALL FAULTS,&rdquo; AND WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                    IMPLIED. &nbsp; CLIENT&nbsp;</span><span style="font-size:12px;font-weight:normal;">UNDERSTANDS THAT
                    LiST OBTAINS DATA INCLUDED IN THE SERVICES FROM THIRD PARTIES, THAT LiST MAKES NO WARRANTIES,
                    WHETHER
                    EXPRESS OR IMPLIED, OF ANY KIND REGARDING THE ACCURACY OR COMPLETENESS OF ANY SUCH DATA, AND THAT
                    LiST
                    IS UNDER NO OBLIGATION TO CORRECT ANY ERROR OR OMISSION THEREIN. LiST MAKES NO WARRANTIES, TERMS OR
                    CONDITIONS OF ANY KIND, EXPRESS, IMPLIED OR STATUTORY, ABOUT LiST&rsquo;S SERVICES OR THE
                    SUITABILITY,
                    LEGALITY OR ACCURACY OF THE INFORMATION, OR SERVICES DESCRIBED OR CONTAINED ON LiST&rsquo;S WEBSITE.
                    &nbsp;TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, LiST EXPRESSLY DISCLAIMS ALL IMPLIED
                    WARRANTIES, TERMS OR CONDITIONS OF SATISFACTORY QUALITY, MERCHANTABILITY, FITNESS FOR A PARTICULAR
                    PURPOSE, TITLE OR NON-INFRINGEMENT.&nbsp;</span><span style="font-size:12px;">LiST<span
                        style="color:black;">&nbsp;LIFE EXPECTANCY REPORTS OBTAINED OR RECEIVED BY CLIENT FROM ANY
                        SOURCE
                        OTHER THAN DIRECTLY FROM&nbsp;</span>LiST<span style="color:black;">&nbsp;ARE EXPRESSLY
                        DISCLAIMED
                        BY&nbsp;</span>LiST<span style="color:black;">&nbsp;AND&nbsp;</span>LiST</span><span
                    style="font-size:12px;color:black;">&nbsp;DOES NOT GUARANTEE THEIR AUTHENTICITY.</span>
            </h1>
            <p
                style='margin-top:0cm;margin-right:0cm;margin-bottom:12.0pt;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;'>
                <span style="font-size:12px;">&nbsp;</span>
            </p>
            <p
                style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;text-align:justify;'>
                <strong><span style='font-size:12px;font-family:"David",sans-serif;'>CONFIDENTIALITY
                        NOTICE:&nbsp;</span></strong><span style='font-size:12px;font-family:"David",sans-serif;'>This
                    document contains confidential information only for the use of intended recipient client of LiST. If
                    you
                    are not the intended recipient, you are hereby notified that any disclosure, copying, distribution,
                    dissemination, or the taking of any action in reliance on the contents of its information is
                    strictly
                    prohibited.</span>
            </p>
            <p
                style='margin-top:0cm;margin-right:0cm;margin-bottom:12.0pt;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;'>
                <span style="font-size:12px;">&nbsp;</span>
            </p>
        </div>

    </div>
    <div class="pdfPowerdBy" style="    text-align: center;
width: 100%;
font-size: 22px;">
        <a href="https://listfunding.com">Powered by LiST AI</a>
        <br />
        <br />
        <span style="color: #68bfbf;">Email: underwriting@listfunding.com</span>
    </div>

</div>
<div style="cursor: pointer; font-size: 20px; color: blue; margin-left: 20px; margin-top: 20px;"
(click)="downloadReadyPdf()">Download LE Assessment</div>



<a [href]="fileUrl" [download]="fileName" #download id="downloadPdf" style="visibility: hidden;">DownloadFile</a>